import { defineRouting } from 'next-intl/routing';

export const supportedLocales = ['en', 'nl'] as const;

export const routing = defineRouting({
  locales: supportedLocales,
  defaultLocale: 'en',
  localeDetection: true,
});

export type Locale = (typeof supportedLocales)[number];
